module.exports = __webpack_public_path__ + "img/proship.043065bb.png";